import { create } from 'zustand'
import { useUser } from '~/@biz_account/useUser/useUser'

const useStore = create<{
  isClosed: boolean
  setIsClosed(isClosed: boolean): void
}>((set) => ({
  isClosed: false,
  setIsClosed: (isClosed) => set({ isClosed }),
}))

export function useRegistrationGiftBanner() {
  const { isClosed, setIsClosed } = useStore()
  const { user } = useUser()

  const isVisible = !isClosed ? user?.meta?.activeCouponType : null

  return {
    isVisible,
    activeCouponType: user?.meta?.activeCouponType ?? null,
    closeBanner: () => setIsClosed(true),
  }
}
